import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/user';
import darkReducer from './dark/dark';

export default configureStore({
  reducer: {
    user:userReducer,
    dark:darkReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})